export const environment = {
  production: true,
  buildId: '3672020053623031',
  configFile: 'config.json',
};
